import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Zoom,
} from "@mui/material";

const DeletePopUp = (props) => {
  const message =
    props?.message || `Dokument ${props?.topic} endgültig löschen?`;

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{backdropFilter: "blur(4px)"}}
      TransitionComponent={Zoom}
    >
      {/* <DialogTitle id="alert-dialog-title">{"Bestätigung löschen"}</DialogTitle> */}
      <DialogContent
        id="alert-dialog-description"
        className="delete-dialog-content"
      >
        {message}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} style={{color: "#38748D"}} data-testid={"btn_"+props.topic+"_cancel"}>
          ABBRECHEN
        </Button>
        <Button onClick={props.handleDelete} style={{color: "#FF3D00"}}  data-testid={"btn_"+props.topic+"_delete"}>
          LÖSCHEN
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePopUp;
